import { render } from "./Tdisk.vue?vue&type=template&id=bb4f0952"
import script from "./Tdisk.vue?vue&type=script&lang=js"
export * from "./Tdisk.vue?vue&type=script&lang=js"

import "./Tdisk.vue?vue&type=style&index=0&id=bb4f0952&lang=scss&Scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__